import {useState,useEffect,useRef} from 'react';
import {authservices} from '../../services/authServices';
import {userservices} from '../../services/userServices';
import {clientservices} from '../../services/clientservices';
import { Toast } from 'primereact/toast';
import { Backbuttons } from '../../components/buttons';
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';

const Departments = () =>{

    const [initialvalues,setValues] = useState({
         'isactive':'active'
    });
    const [initialroles,setRoles] = useState([]);
    const [initialdepartments,setDepartments] = useState([]);
    const [departtype,setdtype] = useState('all');
    const toast = useRef(null);
    
  
    useEffect(()=>{
        getDepartment();
       
    },[])  

    const handleChanges = (e) =>{
       setValues((prevdata)=>{
            return {
                ...prevdata,
                [e.target.name]:e.target.value  
            } 
       });  
    }

    const createdepartment = (e)=>{
        e.preventDefault();
        let data = initialvalues; 
        clientservices.createdepartment(data).then((response)=>{
            // console.log(response);
           if(response.status == 200){
              toast.current.show({ severity: 'success', summary: 'Department', detail: 'Department added Successfully' }); 
              getDepartment();
            }else{
              toast.current.show({ severity: 'error', summary: 'Department', detail: response.data.data });      
           }      
        }).catch((error)=>{
            console.log(error);
            toast.current.show({ severity: 'error', summary: 'Department', detail: 'Error' });  
        });  
    }

    const getDepartment = () =>{
        let id = departtype;
        clientservices.getDepartment(id).then((response)=>{
            if(response.status == 200){
                // let arraydata= JSON.parse(response.data);
                setDepartments(response.data.data);
            }else{
                setDepartments([]); 
            }      
         }).catch((error)=>{
            setDepartments([]);
         });   
         
    }

    const displayDepartments = () =>{
        let dataobj = []; 
        // console.log(initialroles);
        initialdepartments.forEach((value,index)=>{    
            // console.log(value.name);
              dataobj.push(<tr>
                <td>{index + 1}</td>
                <td>{value.name}</td>  
                <td> <Tag severity="success" value={value.isactive} rounded></Tag></td>
                <td>
                    <button className='btn btn-white-custom btn-sm'><i className='icon icon-note'></i></button>
                    &nbsp;
                    <button className='btn btn-white-custom btn-sm'><i className='icon icon-trash txt-error icon-style'></i></button>
                </td>
                </tr>);     
        });
        return dataobj;
    }   

     return(<>
          <Toast ref={toast} /> 
          <Bredcrum title={'Department'}/>
           <div className="card">
           <div className="card-body">
           <form onSubmit={(e)=>createdepartment(e)}>
            <div class="row">
                <div className="col-md-3"> 
                 <div class="form-group">
                    <label for="name">Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        placeholder="Enter name"
                        onChange={handleChanges}
                    />
                 </div>
                </div>
                
                <div className="col-md-3"> 
                    <div class="form-group">
                        <label for="email2">Status</label>
                        <select className="form-control" required name="isactive" onChange={handleChanges}>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            {/* <option value="superadmin">Superadmin</option>
                            <option value="admin">Admin</option>
                            <option value="user">User</option> */}
                        </select>
                    </div>
                </div>

                <div className="col-md-3">
                   <div style={{marginTop:'26px'}}></div> 
                   <div class="form-group">
                      <button className="btn btn-success-custom" type="submit">Save</button>
                   </div>
                  
                </div>
                
             </div>
             </form>
             </div>
             </div>
             <div className="card">
                 
               <div class="row">
                  <div className='col-md-12'>
                  <div class="table-responsive">
                    <table
                        id="basic-datatables"
                        class="display table  table-hover"
                      >
                        <thead>
                          <tr>
                            <th>SR No</th>
                            <th>Name</th>  
                            <th>Active</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                           {displayDepartments()}
                        </tbody>
                      </table>
                      </div>  
                                
                  </div>              
               </div>           
            </div>
           
     </>);   
}

export default Departments;